import { Component, OnInit, WritableSignal, signal, inject } from '@angular/core';
import { ProjectPlanningComponent } from '../project-planning/project-planning.component';
import { ProjectDetailComponent } from '../project-detail/project-detail.component';
import { ContextService } from '../../services/context.service';
import { ActivatedRoute } from '@angular/router';
import { DxButtonModule, DxLoadIndicatorModule, DxMultiViewModule, DxTabsModule } from 'devextreme-angular';
import { ProjectFooterPanelComponent } from '../project-footer-panel/project-footer-panel.component';
import { ProjectDto } from '../../shared/generated/backend';
import { ProjectService } from '../../shared/generated/backend';
import { SharedModule } from '../../shared/shared.module';
import notify from 'devextreme/ui/notify';
import { ProjectCourierComponent } from '../project-courier/project-courier.component';
import { TranslateService } from '@ngx-translate/core';
import {
  BadgeVariantComponent,
  Shape,
} from '../../shared/components/badge-variant/badge-variant/badge-variant.component';

type ComponentType = 'planning' | 'detail' | 'courier';
interface Tab {
  text: string;
  type: ComponentType;
}
@Component({
  selector: 'app-project-context-view',
  imports: [
    SharedModule,
    ProjectPlanningComponent,
    ProjectDetailComponent,
    DxLoadIndicatorModule,
    DxTabsModule,
    DxMultiViewModule,
    DxButtonModule,
    ProjectFooterPanelComponent,
    ProjectCourierComponent,
    BadgeVariantComponent,
  ],
  templateUrl: './project-context-view.component.html',
  styleUrl: './project-context-view.component.scss',
})
export class ProjectContextViewComponent implements OnInit {
  private translationService = inject(TranslateService);
  private contextService = inject(ContextService);
  private projectService = inject(ProjectService);
  private activatedRoute = inject(ActivatedRoute);
  project!: WritableSignal<ProjectDto>;
  readonly projectNo: WritableSignal<number | null> = signal(null);
  readonly Shape = Shape;
  selectedTabIndex: number = 0;

  readonly _tabs: Tab[] = [
    {
      text: 'Planung',
      type: 'planning',
    },
    {
      text: 'Detail',
      type: 'detail',
    },
    {
      text: 'Kurier',
      type: 'courier',
    },
  ];

  tabs: Tab[] = this._tabs;

  async ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      const id = params['projectId'];
      if (!id) return;
      this.loadProjectDetail(id);
    });
  }

  reloadProjectDetail = () => {
    if (!this.projectNo()) return;
    this.loadProjectDetail(this.projectNo()!);
  };

  loadProjectDetail(id: number) {
    this.projectService.getProjectDetails(id).subscribe({
      next: project => {
        if (this.project) {
          this.project.set(project);
        } else this.project = signal(project);
        this.tabs = this._tabs.filter(tab => {
          if (project.isCourier) {
            return true;
          }
          return tab.type != 'courier'; // hide courier tab
        });
        this.projectNo.set(id);
      },
      error: err => {
        notify({ message: err.statusText, shading: false }, 'error', 3000);
        console.error(err);
        this.close();
      },
    });
  }

  close() {
    this.contextService.closeContextView();
  }
}
